// token-refresh.service.ts
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginApiResponse } from 'src/app/api/identity/models';
import { AuthService } from 'src/app/api/identity/services';

@Injectable({
  providedIn: 'root',
})
export class TokenRefreshService {
  constructor(private authService: AuthService) {}

  refreshToken(): Observable<LoginApiResponse> {
    // Use only for making API call, not for handling headers
    return this.authService.refreshToken();
  }
}
